const GET_STATES = 'GET_STATES';
const SET_STATES = 'SET_STATES';

export {
    GET_STATES,
    SET_STATES
};